import { apiGet } from "@/modules/client/services/index";

export function index() {
  return apiGet("/api/me/notification");
}
